import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { LocationPage } from './location';
import { AgmCoreModule } from '@agm/core';

@NgModule({
  declarations: [
    LocationPage,
  ],
  imports: [
    IonicPageModule.forChild(LocationPage),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBqQDcH2FfuB5tg_3cdhFtc4nGuKcz79uM',
      libraries: ["places"]
    }),
  ],
  entryComponents: [
    LocationPage
  ]
})
export class LocationPageModule {}



// WEBPACK FOOTER //
// ./src/pages/location/location.module.ts